import React from 'react';
import { Box } from '@material-ui/core';
import styled, { css } from 'styled-components';

export const StyledFlexBox = styled(({ gap, ...props }) => <Box {...props} />)`
  ${({ gap }) => css`
    gap: ${gap}px;
  `}
`;
